import { actRequest } from "./request/request"
import { RESP } from "./request"

export const requestGetUserStatus = async () => {
    return actRequest.get<
        null,
        RESP<{ avatar: string | null; isRecallUser: boolean }>
    >("/status")
}

export const requestCompleteShare = async (type: "main" | "recall" = "main") => {
    return actRequest.post<null, RESP<Record<string, never>>>("/share", {
        type,
    })
}

// TODO: no third-party equivalent — collection endpoint does not exist in strange-go-game API
// export const requestUnlockCollection = ...
